import { Grid, Typography } from "@mui/material";
import { getLineupFpts, getLineupScore } from "./utils";

export default function GameScore({ lineupA, lineupB, userA, userB }) {
  if (lineupA.length === 0 || lineupB.length === 0) {
    return null;
  }
  return (
    <Grid container spacing={2} sx={{ my: 1 }}>
      <Grid item xs={6}>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ textAlign: "center" }}>
              {userA ? userA.username : "Unknown"}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ textAlign: "center" }}>
              {userA
                ? `${userA.wins}-${userA.draws}-${userA.losses} (Rank: ${userA.rank})`
                : ""}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h2" sx={{ textAlign: "center" }}>
              {getLineupScore(lineupA)}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ textAlign: "center" }}>
              {getLineupFpts(lineupA)}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ textAlign: "center" }}>
              {userB ? userB.username : "Unknown"}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ textAlign: "center" }}>
              {userB
                ? `${userB.wins}-${userB.draws}-${userB.losses} (Rank: ${userB.rank})`
                : ""}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h2" sx={{ textAlign: "center" }}>
              {getLineupScore(lineupB)}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ textAlign: "center" }}>
              {getLineupFpts(lineupB)}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
